export enum Constants {
  MRRDisplay = 'Chargebee Retention MRR',
  PurchaseLink = 'https://www.chargebee.com/pricing/?product_name=retention',
  GrowthPlaysOverviewDocs = 'https://www.chargebee.com/docs/growth/plays/plays-overview',
}
